export default class ProcessKanbanSettingsModel {
  flagHabilitaKanban!: number;

  urlKanbanApp!: string;

  urlKanbanAPI!: string;
}
